import { type LayoutConfig } from './layoutTemplates';

export type OpsPresetTemplate = {
  preset_id: string;
  name_key: string;
  description_key: string;
  originating_prompt_key: string;
  config: LayoutConfig;
};

function toIsoDate(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function toIsoMonth(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

export function getOpsPresets(now: Date = new Date()): OpsPresetTemplate[] {
  return [
    {
      preset_id: 'ops-settlement-control',
      name_key: 'templates.items.settlementControl.name',
      description_key: 'templates.items.settlementControl.description',
      originating_prompt_key: 'templates.items.settlementControl.prompt',
      config: {
        version: 1,
        tiles: [
          {
            id: 'preset-settlements',
            surface: 'settlement_list',
            payload: { filters: { status: 'instructed' } },
            grid: { x: 0, y: 0, w: 7, h: 9 },
          },
          {
            id: 'preset-cash',
            surface: 'cash_balances',
            payload: { filters: { currency: 'USD', asOfDate: toIsoDate(now) } },
            grid: { x: 7, y: 0, w: 5, h: 5 },
          },
          {
            id: 'preset-matched-book',
            surface: 'matched_book',
            payload: { filters: { currency: 'USD' } },
            grid: { x: 7, y: 5, w: 5, h: 4 },
          },
        ],
      },
    },
    {
      preset_id: 'ops-closeout-control',
      name_key: 'templates.items.closeoutControl.name',
      description_key: 'templates.items.closeoutControl.description',
      originating_prompt_key: 'templates.items.closeoutControl.prompt',
      config: {
        version: 1,
        tiles: [
          {
            id: 'preset-closeout',
            surface: 'closeout_batches',
            payload: { filters: { date: toIsoDate(now) } },
            grid: { x: 0, y: 0, w: 7, h: 9 },
          },
          {
            id: 'preset-journals',
            surface: 'journal_list',
            payload: { filters: { period: toIsoMonth(now) } },
            grid: { x: 7, y: 0, w: 5, h: 4 },
          },
          {
            id: 'preset-netting',
            surface: 'execute_netting',
            payload: { currency: 'USD', payment_date: toIsoDate(now) },
            grid: { x: 7, y: 4, w: 5, h: 5 },
          },
        ],
      },
    },
    {
      preset_id: 'pm-dashboard',
      name_key: 'templates.items.pmDashboard.name',
      description_key: 'templates.items.pmDashboard.description',
      originating_prompt_key: 'templates.items.pmDashboard.prompt',
      config: {
        version: 1,
        tiles: [
          {
            id: 'preset-pm-summary',
            surface: 'portfolio_summary',
            payload: {},
            grid: { x: 0, y: 0, w: 12, h: 4 },
          },
          {
            id: 'preset-pm-positions',
            surface: 'portfolio_positions',
            payload: {},
            grid: { x: 0, y: 4, w: 7, h: 8 },
          },
          {
            id: 'preset-pm-risk',
            surface: 'portfolio_risk',
            payload: {},
            grid: { x: 7, y: 4, w: 5, h: 8 },
          },
        ],
      },
    },
  ];
}
